import type { InterruptionType } from "@octopusdeploy/octopus-server-client";
export type PrimaryPendingInterruptionType = Exclude<InterruptionType, "GuidedFailure">;
/*
 * Returns the primary/contributing interruption type. Interruption types that require specific user interactions in Octopus are given higher priority.
 */
export function getPrimaryPendingInterruptionType(pendingInterruptionTypes: InterruptionType[]): PrimaryPendingInterruptionType {
    //we prioritize user-interaction icons if there are multiple
    if (pendingInterruptionTypes.some((t) => t === "ManualIntervention" || t === "GuidedFailure")) {
        return "ManualIntervention";
    }
    else if (pendingInterruptionTypes.some((t) => t === "PullRequestCompletion")) {
        return "PullRequestCompletion";
    }
    else if (pendingInterruptionTypes.some((t) => t === "ArgoCDApplicationSync")) {
        return "ArgoCDApplicationSync";
    }
    else {
        //if there is a non-expected value
        throw Error(`Unexpected type ${pendingInterruptionTypes[0]} for InterruptionType`);
    }
}
